function debounce (fn, delay = 300) {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), delay)
  }
}

export const searchMixins = {
  methods: {
    /**
     * Searching through a field's options and returns matching results
     * @param options   An object of possible suggestions with properties 'opts' and 'searchable'
     * @param query     The query to search with
     */
    handleSearch (options, query, field) {
      if (!options) return []
      if (!(options.searchable && options.opts)) return []
      let ret1 = options.searchable.reduce((a, e, i) => e.split(' ')[field.label === 'Account' ? e.split(' ').length - 1 : 0].includes(query.toLowerCase().replace(/-/g, '')) ? a.concat(i) : a, [])
      let ret2 = options.searchable.reduce((a, e, i) => e.split(' ')[field.label === 'Account' ? e.split(' ').length - 1 : 0].includes(query) ? a.concat(i) : a, [])
      let ret3 = options.searchable.reduce((a, e, i) => e.substring(e.indexOf(' ') + 1).includes(query.toLowerCase()) ? a.concat(i) : a, [])
      return [...ret1, ...ret2, ...ret3].filter((item, i, ar) => ar.indexOf(item) === i).map(v => options.opts[v]).sort((a, b) => a.label.localeCompare(b.label))
    },
    /**
     * Handles searching for non-remote autocomplete fields
     * @param query
     * @param cb
     * @param ref
     * @param field
     */
    /* eslint-disable */
    async _autocompleteLocalSearch({ query, ref, field }, cb) {
      let results = (field.options() && field.options().opts) ? field.options().opts : []
      if (field.name === 'relieves' && results.length > 0) {
        results = results.filter(v => v.label.toLowerCase().indexOf(query.toLowerCase()) !== -1)
      }

      if (field.actionPayload && !field.actionPayload.noApi) {
        let updatedQuery = { active: 'True', search: query, page_size: 200 }
        if (field.actionPayload.hasOwnProperty('query') && typeof field.actionPayload.query === 'object') {
          updatedQuery = { ...updatedQuery, ...field.actionPayload.query }
        }
        const payload = { ...field.actionPayload, query: updatedQuery }
        await this.$store.dispatch('fetchWithQuery', payload)
        results = this.handleSearch(field.options(), query, field)
        if (field && field.name) {
          this.searchKeys = { ...(this.searchKeys || {}), [field.name]: query }
          this.searchKey = field.name === 'account' ? query : this.searchKey
        }
      }
      cb(results)
      if (typeof this.highlightFirstAutocompleteResult === 'function') {
        this.highlightFirstAutocompleteResult(ref)
      }
    }
  },

  created () {
    // expose debounced version globally so external components can call it
    this.autocompleteLocalSearch = debounce(this._autocompleteLocalSearch, 500)
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/SearchMixins.js